{
  "schedule-date-time":"Horario Fecha / hora",
  "cancel":"Cancelar",
  "schedule-meeting":"Agendar Reunión",
  "details":"Detalles",
  "attendees":"Asistentes",
  "schedule-closing":"Programar Cierre",
  "date":"Fecha",
  "start":"Inicio",
  "end":"Fin",
  "re-schedule-meeting":" Re-agendar Reunion",
  "you-have-no-meetings":"Aún no tiene reuniones programadas",
  "here-you-will":"Aquí verás los detalles de tu próxima reunión.",
  "add-attendee":"Agregar Asistente",
  "not-email":"El usuario no tiene correo electrónico.",
  "confirm-signature-request": "Confirmar solicitud de firma electrónica",
  "document-for-ron": "Documento para RON",
  "document-signature-request-send": "Las solicitudes de firma del documento se enviaron correctamente",
  "copy-url": "Copiar url",
  "verify-attendees-message": "Verifique que tiene la dirección de correo electrónico de todos los asistentes en la",
  "parties-link": "Partes",
  "screen-suffix": "pantalla",
  "scheduleDateTimeLabel": "Programar Fecha / Hora",
  "attendee-name": "Nombre",
  "attendee-email": "Correo electrónico",
  "attendee-url": "URL",
  "attendee-roles": "Roles",
  "attendee-add": "Agregar",
  "attendee-remove": "Quitar",
  "attendee-add-aria": "Agregar a {{name}} ({{email}}) a los asistentes",
  "attendee-remove-aria": "Quitar a {{name}} ({{email}}) de los asistentes",
  "attendee-move-to-attendees-aria": "Mover a {{name}} ({{email}}) a los asistentes",
  "attendee-move-to-parties-aria": "Mover a {{name}} ({{email}}) a las partes",
  "attendee-actions": "Acciones",
  "meeting-updated": "Reunión actualizada",
  "attendees-selected": "{{count}} seleccionados",
  "no-parties-match": "Ninguna parte coincide con tu búsqueda",
  "reissue-invitation": "Enviar una nueva invitación (reemplaza el evento anterior del calendario)"
}